(() => {
  'use strict';

  const geoBuild = 'v3.6.1-shopify-first-local-signal';

  const workerUrl =
    'https://likebrands-geo-country.likebrands.workers.dev/';

  const greekOrigin = 'https://likebrands.gr';
  const europeanOrigin = 'https://likebrands.com';

  const hostname = window.location.hostname
    .replace(/^www\./, '')
    .toLowerCase();

  if (
    hostname !== 'likebrands.gr' &&
    hostname !== 'likebrands.com'
  ) {
    return;
  }

  const configElement = document.getElementById(
    'GeoStoreRecommendationConfig'
  );

  if (!configElement) return;

  let geoConfig;

  try {
    geoConfig = JSON.parse(
      configElement.textContent || '{}'
    );
  } catch (error) {
    return;
  }

  const currentShopifyCountry = String(
    geoConfig.currentShopifyCountry || ''
  )
    .trim()
    .toUpperCase();

  const availableCountries = new Set(
    (
      Array.isArray(
        geoConfig.availableCountries
      )
        ? geoConfig.availableCountries
        : []
    ).map((country) => {
      return String(country || '')
        .trim()
        .toUpperCase();
    })
  );

  const supportedEuropeanCountries = new Set([
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE'
  ]);

  const recommendation = document.getElementById(
    'GeoStoreRecommendation'
  );

  if (!recommendation) return;

  const panel = recommendation.querySelector(
    '.geo-store-recommendation__panel'
  );

  const title = recommendation.querySelector(
    '#GeoStoreRecommendationTitle'
  );

  const text = recommendation.querySelector(
    '#GeoStoreRecommendationText'
  );

  const link = recommendation.querySelector(
    '[data-geo-store-link]'
  );

  const stayButton = recommendation.querySelector(
    '[data-geo-store-stay]'
  );

  const closeButton = recommendation.querySelector(
    '[data-geo-store-close]'
  );

  if (
    !panel ||
    !title ||
    !text ||
    !link ||
    !stayButton ||
    !closeButton
  ) {
    return;
  }

  const initialUrl = new URL(window.location.href);

  const debugMode =
    initialUrl.searchParams.get('geo_debug') === '1';

  const debug = (...args) => {
    if (!debugMode) return;

    console.log('[Likebrands Geo]', ...args);
  };

  debug('Geo build loaded', geoBuild);

  const dismissDurationMs =
    30 * 24 * 60 * 60 * 1000;

  const attemptGuardDurationMs =
    60 * 1000;

  const syncStateKey =
    'likebrands_geo_country_sync_state_v3';

  const countryCacheKey =
    'likebrands_geo_detected_country_session_v1';

  const workerTimeoutMs = 1800;
  const shopifyTimeoutMs = 2000;

  let previousRootOverflow = '';
  let previouslyFocusedElement = null;
  let activeConfiguration = null;
  let modalIsOpen = false;

  const configurations = {
    toGreekStore: {
      storageKey:
        'likebrands_geo_dismiss_to_gr_v3',
      title: 'Βρίσκεσαι στην Ελλάδα;',
      text:
        'Επισκέψου το ελληνικό μας κατάστημα για αγορές και αποστολές εντός Ελλάδας.',
      cta: 'Μετάβαση στο likebrands.gr',
      stay:
        'Παραμονή στο ευρωπαϊκό κατάστημα',
      closeLabel: 'Κλείσιμο'
    },

    toSupportedEuropeanStore: {
      storageKey:
        'likebrands_geo_dismiss_to_supported_com_v3',
      title: 'Shopping from outside Greece?',
      text:
        'Our European store ships to your country, with content in English.',
      cta: 'Visit likebrands.com',
      stay: 'Stay on the Greek store',
      closeLabel: 'Close'
    },

    toInternationalWebsite: {
      storageKey:
        'likebrands_geo_dismiss_to_international_com_v3',
      title:
        'Looking for our international website?',
      text:
        'Browse our website in English, we ship to many countries worldwide.',
      cta: 'Visit likebrands.com',
      stay: 'Stay on the Greek store',
      closeLabel: 'Close'
    }
  };

  const readStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (
    storage,
    key,
    value
  ) => {
    try {
      storage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  };

  const removeStorage = (
    storage,
    key
  ) => {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Fail-safe.
    }
  };

  const readJsonStorage = (
    storage,
    key
  ) => {
    const rawValue = readStorage(
      storage,
      key
    );

    if (!rawValue) return null;

    try {
      return JSON.parse(rawValue);
    } catch (error) {
      removeStorage(storage, key);
      return null;
    }
  };

  const setTimedDismissal = (
    storageKey
  ) => {
    writeStorage(
      localStorage,
      storageKey,
      JSON.stringify({
        expiresAt:
          Date.now() + dismissDurationMs
      })
    );
  };

  const hasActiveDismissal = (
    storageKey
  ) => {
    const value = readJsonStorage(
      localStorage,
      storageKey
    );

    if (!value) return false;

    const expiresAt = Number(
      value.expiresAt
    );

    if (
      Number.isFinite(expiresAt) &&
      expiresAt > Date.now()
    ) {
      return true;
    }

    removeStorage(
      localStorage,
      storageKey
    );

    return false;
  };

  const isValidCountryCode = (
    countryCode
  ) => {
    return /^[A-Z]{2}$/.test(
      countryCode
    );
  };

  const readCachedCountry = () => {
    const cachedValue = readJsonStorage(
      sessionStorage,
      countryCacheKey
    );

    if (!cachedValue) return null;

    const country = String(
      cachedValue.country || ''
    )
      .trim()
      .toUpperCase();

    if (
      country === 'XX' ||
      !isValidCountryCode(country)
    ) {
      removeStorage(
        sessionStorage,
        countryCacheKey
      );

      return null;
    }

    return {
      country,
      source: 'cache',
      originalSource: String(
        cachedValue.source || ''
      )
    };
  };

  const saveCachedCountry = (
    country,
    source
  ) => {
    if (
      country === 'XX' ||
      !isValidCountryCode(country)
    ) {
      return;
    }

    writeStorage(
      sessionStorage,
      countryCacheKey,
      JSON.stringify({
        country,
        source,
        cachedAt: Date.now()
      })
    );
  };

  const isSupportedEuropeanCountry = (
    countryCode
  ) => {
    return (
      isValidCountryCode(countryCode) &&
      supportedEuropeanCountries.has(
        countryCode
      )
    );
  };

  const isAvailableEuropeanCountry = (
    countryCode
  ) => {
    return (
      isSupportedEuropeanCountry(
        countryCode
      ) &&
      availableCountries.has(
        countryCode
      )
    );
  };

  const buildRelativeUrl = (url) => {
    return (
      url.pathname +
      (url.search || '') +
      (url.hash || '')
    );
  };

  const removeGeoParameters = (
    sourceUrl
  ) => {
    const cleanedUrl = new URL(
      sourceUrl.toString()
    );

    cleanedUrl.searchParams.delete(
      'geo_sync'
    );

    cleanedUrl.searchParams.delete(
      'geo_country'
    );

    return cleanedUrl;
  };

  const replaceCurrentUrl = (
    cleanedUrl
  ) => {
    try {
      window.history.replaceState(
        window.history.state,
        '',
        buildRelativeUrl(cleanedUrl)
      );

      return true;
    } catch (error) {
      debug(
        'Could not clean URL',
        error
      );

      return false;
    }
  };

  const getAttemptKey = (
    type,
    countryCode
  ) => {
    return (
      'likebrands_geo_' +
      type +
      '_attempt_' +
      countryCode
    );
  };

  const clearAttempt = (
    type,
    countryCode
  ) => {
    removeStorage(
      sessionStorage,
      getAttemptKey(
        type,
        countryCode
      )
    );
  };

  const hasRecentAttempt = (
    type,
    countryCode
  ) => {
    const attemptKey = getAttemptKey(
      type,
      countryCode
    );

    const attempt = readJsonStorage(
      sessionStorage,
      attemptKey
    );

    if (!attempt) return false;

    const attemptedAt = Number(
      attempt.attemptedAt
    );

    if (
      Number.isFinite(attemptedAt) &&
      Date.now() - attemptedAt <
        attemptGuardDurationMs
    ) {
      return true;
    }

    removeStorage(
      sessionStorage,
      attemptKey
    );

    return false;
  };

  const setAttempt = (
    type,
    countryCode
  ) => {
    writeStorage(
      sessionStorage,
      getAttemptKey(
        type,
        countryCode
      ),
      JSON.stringify({
        attemptedAt: Date.now()
      })
    );
  };

  const submitLocalization = ({
    countryCode,
    returnTo
  }) => {
    if (
      hostname !== 'likebrands.com' ||
      !isAvailableEuropeanCountry(
        countryCode
      )
    ) {
      debug(
        'Localization submission rejected',
        {
          hostname,
          countryCode,
          supported:
            isSupportedEuropeanCountry(
              countryCode
            ),
          available:
            availableCountries.has(
              countryCode
            )
        }
      );

      return false;
    }

    const form =
      document.createElement('form');

    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;

    const methodInput =
      document.createElement('input');

    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'PUT';

    const countryInput =
      document.createElement('input');

    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    countryInput.value = countryCode;

    const returnInput =
      document.createElement('input');

    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value =
      returnTo || '/';

    form.appendChild(methodInput);
    form.appendChild(countryInput);
    form.appendChild(returnInput);

    document.body.appendChild(form);

    debug(
      'Submitting localization',
      {
        countryCode,
        returnTo:
          returnInput.value,
        action: form.action
      }
    );

    form.submit();

    return true;
  };

  const saveSynchronizedState = (
    countryCode
  ) => {
    writeStorage(
      localStorage,
      syncStateKey,
      JSON.stringify({
        detectedIpCountry:
          countryCode,
        automaticCountry:
          countryCode,
        manualOverride: false,
        synchronizedAt:
          Date.now()
      })
    );
  };

  /*
   * Επεξεργασία μετάβασης από το .gr
   * προς το .com.
   */
  const processIncomingGeoSync = () => {
    if (hostname !== 'likebrands.com') {
      return false;
    }

    const incomingUrl = new URL(
      window.location.href
    );

    const hasGeoParameters =
      incomingUrl.searchParams.has(
        'geo_sync'
      ) ||
      incomingUrl.searchParams.has(
        'geo_country'
      );

    if (!hasGeoParameters) {
      return false;
    }

    const geoSync =
      incomingUrl.searchParams.get(
        'geo_sync'
      );

    const geoCountry = String(
      incomingUrl.searchParams.get(
        'geo_country'
      ) || ''
    )
      .trim()
      .toUpperCase();

    const cleanedUrl =
      removeGeoParameters(incomingUrl);

    replaceCurrentUrl(cleanedUrl);

    const isValidIncomingRequest =
      geoSync === '1' &&
      isValidCountryCode(geoCountry) &&
      supportedEuropeanCountries.has(
        geoCountry
      ) &&
      availableCountries.has(
        geoCountry
      );

    debug(
      'Incoming geo sync detected',
      {
        geoSync,
        geoCountry,
        isValidIncomingRequest,
        cleanedUrl:
          buildRelativeUrl(
            cleanedUrl
          )
      }
    );

    if (!isValidIncomingRequest) {
      debug(
        'Invalid incoming geo parameters ignored',
        {
          geoSync,
          geoCountry
        }
      );

      return false;
    }

    if (
      currentShopifyCountry ===
      geoCountry
    ) {
      clearAttempt(
        'incoming',
        geoCountry
      );

      saveSynchronizedState(
        geoCountry
      );

      debug(
        'Incoming country already active',
        geoCountry
      );

      return true;
    }

    if (
      hasRecentAttempt(
        'incoming',
        geoCountry
      )
    ) {
      debug(
        'Incoming sync temporarily blocked by attempt guard',
        geoCountry
      );

      return true;
    }

    setAttempt(
      'incoming',
      geoCountry
    );

    submitLocalization({
      countryCode: geoCountry,
      returnTo:
        buildRelativeUrl(
          cleanedUrl
        )
    });

    return true;
  };

  /*
   * Incoming sync εκτελείται πριν
   * από το αίτημα προς τον Worker.
   */
  if (processIncomingGeoSync()) {
    return;
  }

  const getFocusableElements = () => {
    return Array.from(
      panel.querySelectorAll(
        [
          'a[href]',
          'button:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      )
    ).filter((element) => {
      return (
        !element.hasAttribute(
          'hidden'
        ) &&
        element.getAttribute(
          'aria-hidden'
        ) !== 'true'
      );
    });
  };

  const restorePageState = () => {
    document.documentElement.style.overflow =
      previousRootOverflow;

    if (
      previouslyFocusedElement &&
      typeof previouslyFocusedElement.focus ===
        'function' &&
      document.contains(
        previouslyFocusedElement
      )
    ) {
      previouslyFocusedElement.focus();
    }

    previouslyFocusedElement = null;
  };

  const closeRecommendation = ({
    rememberChoice = true
  } = {}) => {
    if (!modalIsOpen) return;

    recommendation.hidden = true;
    modalIsOpen = false;

    if (
      rememberChoice &&
      activeConfiguration
    ) {
      setTimedDismissal(
        activeConfiguration.storageKey
      );
    }

    activeConfiguration = null;

    restorePageState();
  };

  const handleModalKeydown = (
    event
  ) => {
    if (!modalIsOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();

      closeRecommendation({
        rememberChoice: true
      });

      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements =
      getFocusableElements();

    if (!focusableElements.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const firstElement =
      focusableElements[0];

    const lastElement =
      focusableElements[
        focusableElements.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement ===
        firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement ===
        lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  closeButton.addEventListener(
    'click',
    () => {
      closeRecommendation({
        rememberChoice: true
      });
    }
  );

  stayButton.addEventListener(
    'click',
    () => {
      closeRecommendation({
        rememberChoice: true
      });
    }
  );

  document.addEventListener(
    'keydown',
    handleModalKeydown
  );

  const showRecommendation = ({
    configuration,
    targetUrl
  }) => {
    const dismissed =
      hasActiveDismissal(
        configuration.storageKey
      );

    if (
      modalIsOpen ||
      dismissed
    ) {
      debug(
        'Recommendation not shown',
        {
          modalIsOpen,
          dismissed,
          storageKey:
            configuration.storageKey
        }
      );

      return;
    }

    activeConfiguration =
      configuration;

    title.textContent =
      configuration.title;

    text.textContent =
      configuration.text;

    link.textContent =
      configuration.cta;

    link.href = targetUrl;

    stayButton.textContent =
      configuration.stay;

    closeButton.setAttribute(
      'aria-label',
      configuration.closeLabel
    );

    previouslyFocusedElement =
      document.activeElement;

    previousRootOverflow =
      document.documentElement.style.overflow;

    recommendation.hidden = false;
    modalIsOpen = true;

    document.documentElement.style.overflow =
      'hidden';

    debug(
      'Recommendation shown',
      {
        storageKey:
          configuration.storageKey,
        targetUrl
      }
    );

    window.requestAnimationFrame(() => {
      link.focus();
    });
  };

  const createSupportedComUrl = (
    countryCode
  ) => {
    const targetUrl = new URL(
      '/',
      europeanOrigin
    );

    targetUrl.searchParams.set(
      'geo_sync',
      '1'
    );

    targetUrl.searchParams.set(
      'geo_country',
      countryCode
    );

    if (debugMode) {
      targetUrl.searchParams.set(
        'geo_debug',
        '1'
      );
    }

    return targetUrl.toString();
  };

  /*
   * Αυτόματος συγχρονισμός όταν ο χρήστης
   * ανοίγει απευθείας το .com.
   */
  const synchronizeEuropeanCountry = (
    visitorCountry
  ) => {
    if (
      hostname !== 'likebrands.com' ||
      !isAvailableEuropeanCountry(
        visitorCountry
      )
    ) {
      debug(
        'Automatic sync skipped: unavailable country',
        visitorCountry
      );

      return;
    }

    const syncState =
      readJsonStorage(
        localStorage,
        syncStateKey
      );

    /*
     * Η σωστή χώρα είναι ήδη ενεργή.
     */
    if (
      currentShopifyCountry ===
      visitorCountry
    ) {
      clearAttempt(
        'auto',
        visitorCountry
      );

      clearAttempt(
        'incoming',
        visitorCountry
      );

      saveSynchronizedState(
        visitorCountry
      );

      debug(
        'Country already synchronized',
        visitorCountry
      );

      return;
    }

    /*
     * Χειροκίνητη επιλογή αναγνωρίζεται
     * μόνο όταν η IP χώρα δεν έχει αλλάξει
     * από το προηγούμενο automatic sync.
     */
    const manualOverrideDetected =
      syncState &&
      syncState.manualOverride !== true &&
      syncState.detectedIpCountry ===
        visitorCountry &&
      syncState.automaticCountry &&
      currentShopifyCountry !==
        syncState.automaticCountry;

    if (manualOverrideDetected) {
      writeStorage(
        localStorage,
        syncStateKey,
        JSON.stringify({
          detectedIpCountry:
            visitorCountry,
          automaticCountry:
            syncState.automaticCountry,
          manualOverride: true,
          manualOverrideForIpCountry:
            visitorCountry,
          manuallySelectedCountry:
            currentShopifyCountry,
          manualOverrideAt:
            Date.now()
        })
      );

      debug(
        'Manual country override detected',
        {
          visitorCountry,
          currentShopifyCountry,
          previousAutomaticCountry:
            syncState.automaticCountry
        }
      );

      return;
    }

    /*
     * Η χειροκίνητη επιλογή προστατεύεται
     * μόνο όσο η IP χώρα παραμένει ίδια.
     */
    if (
      syncState &&
      syncState.manualOverride === true &&
      syncState.manualOverrideForIpCountry ===
        visitorCountry
    ) {
      debug(
        'Automatic sync blocked by manual override',
        syncState
      );

      return;
    }

    /*
     * Αν άλλαξε η IP χώρα, παλιό manual
     * override δεν μπλοκάρει το νέο sync.
     */
    if (
      syncState &&
      syncState.manualOverride === true &&
      syncState.manualOverrideForIpCountry !==
        visitorCountry
    ) {
      removeStorage(
        localStorage,
        syncStateKey
      );
    }

    if (
      hasRecentAttempt(
        'auto',
        visitorCountry
      )
    ) {
      debug(
        'Automatic sync temporarily blocked by attempt guard',
        visitorCountry
      );

      return;
    }

    setAttempt(
      'auto',
      visitorCountry
    );

    submitLocalization({
      countryCode: visitorCountry,
      returnTo:
        window.location.pathname +
        window.location.search +
        window.location.hash
    });
  };

  const getCountryFromWorker = async () => {
    const controller =
      new AbortController();

    const timeoutId =
      window.setTimeout(() => {
        controller.abort();
      }, workerTimeoutMs);

    try {
      const response = await fetch(
        workerUrl,
        {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store',
          signal: controller.signal
        }
      );

      if (!response.ok) {
        throw new Error(
          'Country request failed with status ' +
            response.status
        );
      }

      const data = await response.json();

      const country = String(
        data?.country || ''
      )
        .trim()
        .toUpperCase();

      if (
        country === '' ||
        country === 'XX' ||
        !isValidCountryCode(country)
      ) {
        debug(
          'Worker country rejected',
          country
        );

        return null;
      }

      debug(
        'Worker response',
        {
          country
        }
      );

      return country;
    } catch (error) {
      debug(
        'Worker request failed safely',
        error
      );

      return null;
    } finally {
      window.clearTimeout(timeoutId);
    }
  };

  const getCountryFromShopify = async () => {
    const controller =
      new AbortController();

    const timeoutId =
      window.setTimeout(() => {
        controller.abort();
      }, shopifyTimeoutMs);

    try {
      const root = String(
        window.Shopify?.routes?.root || '/'
      );

      const endpoint = new URL(
        root +
          'browsing_context_suggestions.json',
        window.location.origin
      );

      endpoint.searchParams.set(
        'country[enabled]',
        'true'
      );

      const response = await fetch(
        endpoint.toString(),
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          },
          signal: controller.signal
        }
      );

      if (!response.ok) {
        throw new Error(
          'Shopify country request failed with status ' +
            response.status
        );
      }

      const data = await response.json();

      const country = String(
        data?.detected_values?.country
          ?.handle || ''
      )
        .trim()
        .toUpperCase();

      if (
        country === '' ||
        country === 'XX' ||
        !isValidCountryCode(country)
      ) {
        debug(
          'Shopify country rejected',
          country
        );

        return null;
      }

      debug(
        'Shopify response',
        {
          country
        }
      );

      return country;
    } catch (error) {
      debug(
        'Shopify fallback failed safely',
        error
      );

      return null;
    } finally {
      window.clearTimeout(timeoutId);
    }
  };

  const detectVisitorCountry = async () => {
    const cachedCountry =
      readCachedCountry();

    if (cachedCountry) {
      debug(
        'Country loaded from session cache',
        cachedCountry
      );

      return cachedCountry;
    }

    const shopifyCountry =
      await getCountryFromShopify();

    if (shopifyCountry) {
      saveCachedCountry(
        shopifyCountry,
        'shopify'
      );

      return {
        country: shopifyCountry,
        source: 'shopify'
      };
    }

    const workerCountry =
      await getCountryFromWorker();

    if (workerCountry) {
      saveCachedCountry(
        workerCountry,
        'cloudflare'
      );

      return {
        country: workerCountry,
        source: 'cloudflare'
      };
    }

    return {
      country: null,
      source: 'unavailable'
    };
  };

  const getGreekLocalSignals = () => {
    const languages = Array.isArray(
      navigator.languages
    )
      ? navigator.languages
      : [navigator.language];

    const languageIsGreek =
      languages.some((language) => {
        const normalizedLanguage =
          String(language || '')
            .trim()
            .toLowerCase();

        return (
          normalizedLanguage === 'el' ||
          normalizedLanguage.startsWith(
            'el-'
          )
        );
      });

    let timeZone = '';

    try {
      timeZone =
        Intl.DateTimeFormat()
          .resolvedOptions()
          .timeZone || '';
    } catch (error) {
      timeZone = '';
    }

    return {
      languages,
      timeZone,
      languageIsGreek,
      timeZoneIsAthens:
        timeZone === 'Europe/Athens',
      looksLikeGreekVisitor:
        languageIsGreek &&
        timeZone === 'Europe/Athens'
    };
  };

  const applyLocalSignalOverride = (
    result
  ) => {
    if (
      !result ||
      typeof result !== 'object'
    ) {
      return result;
    }

    const country = String(
      result.country || ''
    )
      .trim()
      .toUpperCase();

    if (
      !country ||
      country === 'GR'
    ) {
      return result;
    }

    const syncState =
      readJsonStorage(
        localStorage,
        syncStateKey
      );

    const manualOverrideApplies =
      syncState &&
      syncState.manualOverride === true &&
      syncState.manualOverrideForIpCountry ===
        country;

    if (manualOverrideApplies) {
      debug(
        'Local-signal override skipped: applicable manual market selection detected',
        {
          detectedCountry: country,
          syncState
        }
      );

      return result;
    }

    const localSignals =
      getGreekLocalSignals();

    if (
      !localSignals.looksLikeGreekVisitor
    ) {
      return result;
    }

    debug(
      'Overriding detected country due to strong Greek local signals',
      {
        detectedCountry: country,
        detectionSource:
          result.source,
        ...localSignals
      }
    );

    return {
      ...result,
      country: 'GR',
      source:
        'local-signal-override',
      originalCountry: country,
      originalSource:
        result.originalSource ||
        result.source
    };
  };

  const handleDetectedCountry = ({
    country,
    source
  }) => {
    debug(
      'Detected country ready',
      {
        country,
        source
      }
    );

    if (!country) {
      debug(
        'No valid country detected; no action taken'
      );

      return;
    }

    /*
     * Ελλάδα στο .gr:
     * καμία ενέργεια.
     */
    if (
      hostname === 'likebrands.gr' &&
      country === 'GR'
    ) {
      debug(
        'Correct Greek storefront'
      );

      return;
    }

    /*
     * Ελλάδα στο .com:
     * πρόταση μετάβασης στο .gr.
     */
    if (
      hostname === 'likebrands.com' &&
      country === 'GR'
    ) {
      showRecommendation({
        configuration:
          configurations.toGreekStore,
        targetUrl: greekOrigin
      });

      return;
    }

    /*
     * Υποστηριζόμενη χώρα στο .gr:
     * μετάβαση στο .com και τοπικό
     * localization POST στο .com.
     */
    if (
      hostname === 'likebrands.gr' &&
      isSupportedEuropeanCountry(
        country
      )
    ) {
      showRecommendation({
        configuration:
          configurations
            .toSupportedEuropeanStore,
        targetUrl:
          createSupportedComUrl(
            country
          )
      });

      return;
    }

    /*
     * Μη υποστηριζόμενη χώρα στο .gr:
     * αγγλικό .com χωρίς country sync.
     */
    if (
      hostname === 'likebrands.gr' &&
      country !== 'GR'
    ) {
      showRecommendation({
        configuration:
          configurations
            .toInternationalWebsite,
        targetUrl:
          europeanOrigin
      });

      return;
    }

    /*
     * Υποστηριζόμενη χώρα στο .com:
     * αυτόματος συγχρονισμός selector.
     */
    if (
      hostname === 'likebrands.com'
    ) {
      synchronizeEuropeanCountry(
        country
      );
    }
  };

  detectVisitorCountry()
    .then(applyLocalSignalOverride)
    .then(handleDetectedCountry)
    .catch((error) => {
      debug(
        'Country detection failed safely',
        error
      );

      /*
       * Fail-safe:
       * καμία εμφάνιση modal,
       * κανένα redirect,
       * καμία αλλαγή χώρας.
       */
    });
})();
